var _circle, _circle2, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9831_106444)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.2727,
    cy: 45.0911,
    r: 42.2727,
    fill: "url(#paint0_linear_9831_106444)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.9544,
    cy: 74.3182,
    r: 42.2727,
    transform: "rotate(75 79.9544 74.3182)",
    fill: "url(#paint1_linear_9831_106444)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9248 3.81836H95.0742C99.5563 3.81861 103.272 7.64882 103.272 12.4775V111.523C103.272 116.352 99.5561 120.181 95.0742 120.182H28.9248C24.4427 120.182 20.7268 116.352 20.7266 111.523V12.4775C20.7266 7.64869 24.4426 3.81838 28.9248 3.81836Z",
    fill: "url(#paint2_linear_9831_106444)",
    stroke: "url(#paint3_linear_9831_106444)",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 25.8097,
    y: 22.9913,
    width: 72.3806,
    height: 72.3806
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(4px)",
      clipPath: "url(#bgblur_1_9831_106444_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 8.00867,
    d: "M64.2412 31.25C64.3657 31.2501 64.427 31.2837 64.4688 31.3213C64.5207 31.3683 64.5666 31.4439 64.624 31.5713L64.625 31.5723C65.5191 33.5364 66.4116 35.5011 67.3076 37.4639C70.2356 43.8876 73.165 50.3136 76.0947 56.7373L84.7363 75.6895C86.4232 79.3889 88.1101 83.0866 89.7988 86.7861V86.7871C89.8615 86.9248 89.8989 87.0188 89.918 87.085C89.8468 87.0961 89.7401 87.1021 89.5801 87.1025H84.3809C82.6813 87.1025 80.9714 87.085 79.2656 87.1133L79.1191 87.1084C78.9875 87.0963 78.8997 87.0627 78.834 87.0176C78.7445 86.956 78.6623 86.8491 78.5781 86.6504H78.5771C77.5192 84.1757 76.4558 81.7003 75.3916 79.2256L72.2041 71.8027C72.1249 71.619 72.0193 71.4661 71.8594 71.3662C71.7014 71.2676 71.5227 71.2403 71.3398 71.2402H71.3389C64.2887 71.2455 57.2367 71.2455 50.1865 71.2402H50.1855C49.9971 71.2403 49.8177 71.2719 49.6611 71.375C49.5436 71.4525 49.4568 71.5587 49.3887 71.6826L49.3262 71.8125C48.2728 74.3045 47.2145 76.7973 46.1562 79.29L42.9863 86.7695C42.9216 86.9229 42.8594 86.9978 42.7988 87.0391C42.7395 87.0793 42.6506 87.1082 42.4893 87.1074L34.3555 87.1006L34.1748 87.0957C34.1351 87.0931 34.1032 87.0885 34.0771 87.084C34.0927 87.0228 34.1274 86.9349 34.1855 86.8057V86.8047C37.8441 78.6333 41.5008 70.4603 45.1611 62.2891C46.7148 58.8201 48.2707 55.3514 49.8262 51.8828C51.3817 48.4142 52.9374 44.9447 54.4912 41.4756C55.0569 40.2106 55.6516 38.9141 55.8926 37.4854C56.0107 36.7902 55.9915 36.2 55.7705 35.6768C55.549 35.1524 55.139 34.7283 54.542 34.3369L54.54 34.3359C54.4416 34.2724 54.3139 34.1818 54.1836 34.1133L54.1807 34.1123C54.0442 34.0426 53.9674 33.9675 53.9229 33.8877C53.8777 33.8067 53.8512 33.6959 53.8594 33.5322L53.8604 33.5312C53.8766 33.1821 53.8808 32.8325 53.8799 32.4844L53.8672 31.4453C53.865 31.3126 53.8941 31.2836 53.8955 31.2822C53.8998 31.2782 53.933 31.2513 54.0635 31.252H54.0645C55.7606 31.2546 57.457 31.2566 59.1533 31.2568L64.2412 31.25ZM60.3857 45.7666C57.8329 51.7868 55.2796 57.8055 52.709 63.8662L52.5615 64.2148H68.916L68.7656 63.8652C66.1452 57.7816 63.5624 51.7788 60.9775 45.7744L60.918 45.6357L60.7676 45.624L60.6973 45.6191C60.6751 45.6178 60.6553 45.6168 60.6357 45.6152L60.4561 45.6006L60.3857 45.7666Z",
    fill: "url(#paint4_linear_9831_106444)",
    stroke: "url(#paint5_linear_9831_106444)",
    strokeWidth: 0.500542
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.546 107.098C84.546 107.87 84.2911 108.587 83.8811 109.083C83.471 109.593 82.8948 109.91 82.2743 109.91H41.7268C40.4746 109.91 39.4551 108.656 39.4551 107.098C39.4551 106.327 39.7099 105.61 40.1199 105.1C40.53 104.59 41.0951 104.273 41.7268 104.273H82.2743C83.5265 104.273 84.546 105.541 84.546 107.098Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_9831_106444_clip_path",
    transform: "translate(-25.8097 -22.9913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.2412 31.25C64.3657 31.2501 64.427 31.2837 64.4688 31.3213C64.5207 31.3683 64.5666 31.4439 64.624 31.5713L64.625 31.5723C65.5191 33.5364 66.4116 35.5011 67.3076 37.4639C70.2356 43.8876 73.165 50.3136 76.0947 56.7373L84.7363 75.6895C86.4232 79.3889 88.1101 83.0866 89.7988 86.7861V86.7871C89.8615 86.9248 89.8989 87.0188 89.918 87.085C89.8468 87.0961 89.7401 87.1021 89.5801 87.1025H84.3809C82.6813 87.1025 80.9714 87.085 79.2656 87.1133L79.1191 87.1084C78.9875 87.0963 78.8997 87.0627 78.834 87.0176C78.7445 86.956 78.6623 86.8491 78.5781 86.6504H78.5771C77.5192 84.1757 76.4558 81.7003 75.3916 79.2256L72.2041 71.8027C72.1249 71.619 72.0193 71.4661 71.8594 71.3662C71.7014 71.2676 71.5227 71.2403 71.3398 71.2402H71.3389C64.2887 71.2455 57.2367 71.2455 50.1865 71.2402H50.1855C49.9971 71.2403 49.8177 71.2719 49.6611 71.375C49.5436 71.4525 49.4568 71.5587 49.3887 71.6826L49.3262 71.8125C48.2728 74.3045 47.2145 76.7973 46.1562 79.29L42.9863 86.7695C42.9216 86.9229 42.8594 86.9978 42.7988 87.0391C42.7395 87.0793 42.6506 87.1082 42.4893 87.1074L34.3555 87.1006L34.1748 87.0957C34.1351 87.0931 34.1032 87.0885 34.0771 87.084C34.0927 87.0228 34.1274 86.9349 34.1855 86.8057V86.8047C37.8441 78.6333 41.5008 70.4603 45.1611 62.2891C46.7148 58.8201 48.2707 55.3514 49.8262 51.8828C51.3817 48.4142 52.9374 44.9447 54.4912 41.4756C55.0569 40.2106 55.6516 38.9141 55.8926 37.4854C56.0107 36.7902 55.9915 36.2 55.7705 35.6768C55.549 35.1524 55.139 34.7283 54.542 34.3369L54.54 34.3359C54.4416 34.2724 54.3139 34.1818 54.1836 34.1133L54.1807 34.1123C54.0442 34.0426 53.9674 33.9675 53.9229 33.8877C53.8777 33.8067 53.8512 33.6959 53.8594 33.5322L53.8604 33.5312C53.8766 33.1821 53.8808 32.8325 53.8799 32.4844L53.8672 31.4453C53.865 31.3126 53.8941 31.2836 53.8955 31.2822C53.8998 31.2782 53.933 31.2513 54.0635 31.252H54.0645C55.7606 31.2546 57.457 31.2566 59.1533 31.2568L64.2412 31.25ZM60.3857 45.7666C57.8329 51.7868 55.2796 57.8055 52.709 63.8662L52.5615 64.2148H68.916L68.7656 63.8652C66.1452 57.7816 63.5624 51.7788 60.9775 45.7744L60.918 45.6357L60.7676 45.624L60.6973 45.6191C60.6751 45.6178 60.6553 45.6168 60.6357 45.6152L60.4561 45.6006L60.3857 45.7666Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9831_106444",
    x1: -13.0565,
    y1: 69.4252,
    x2: 148.319,
    y2: -56.7656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A7CC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00FFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9831_106444",
    x1: 24.6252,
    y1: 98.6523,
    x2: 186.001,
    y2: -27.5384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A7CC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00FFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9831_106444",
    x1: 26.772,
    y1: 42.2729,
    x2: 99.1476,
    y2: 96.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08A0CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03E2DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9831_106444",
    x1: 37.4811,
    y1: 2.81836,
    x2: 21.329,
    y2: 114.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9831_106444",
    x1: 37.0004,
    y1: 84.1816,
    x2: 86.9999,
    y2: 34.1821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9831_106444",
    x1: 37.797,
    y1: 35.4329,
    x2: 84.9117,
    y2: 85.8094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9831_106444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 124,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAGradient);
export default __webpack_public_path__ + "static/media/a-gradient.889ff52bdd339088ba8cf96f62b52a16.svg";
export { ForwardRef as ReactComponent };